import Vue from "vue"

const path = "qr"

export default {
    generateFromScrape(data) {
        return Vue.prototype.$http.post(`${path}/ticketmaster/am-scrape-generate`, { data })
    }
}
